<template>
  <div>
    <van-sticky>
    <van-nav-bar
      title="提现记录"
      left-text="返回"
      sticky
      left-arrow
      @click-left="goBack"
    />
  </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
      <van-panel v-for="item in list" :title="item.wx_partner_trade_no" :status="item.status_txt" style="margin-bottom:20px!important;">
              <div class="orderCon">
                <div>提现金额：￥{{item.pay}}</div>
                <div>提交时间: {{item.create_time}}</div>
                <div v-if="item.status==2">原因：{{item.reason}}（{{item.act_time}}）</div>
                <div v-if="item.status==4">原因：{{failReason(item)}}</div>
                <div v-if="item.status==3||item.status==9">处理时间: {{item.act_time}}</div>
                <div v-if="item.status==10">请到微信确认收款，超过 24 小时未确认将自动退回</div>
                <template v-if="item.status==9">
                  <div>流水号: {{item.wx_payment_no}}</div>
                  <div>结算时间: {{item.wx_payment_time}}</div>
                </template>
              </div>
              <div slot="footer" v-if="item.status==9">
                结算渠道: 微信零钱
              </div>
              <div slot="footer" v-if="item.status==4">
                不要着急，系统会自行处理~
              </div>
              <div slot="footer" v-if="item.status==10" class="confirmBox">
                <van-button size="small" type="primary" round :loading="confirmingId===item.id" @click="confirmReceive(item)">去微信确认收款</van-button>
              </div>
            </van-panel>
            
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import * as ajax from "@/api/common"
import util from '@/libs/util'
import { confirmReceipt } from '@/libs/transfer'
export default {
  name: 'withdrawalLogPage',
  data() {
    return {
      list:[],
      confirmingId:0,
      loading:false,
      finished:false,
      activeNames:1,
      userInfo:false,
      isLoading:false,
      filter:{

      },
      page:{
        current_page:0,
        page_total:1,
        count:0,
        page_size:10,
      },
    }
  },
  mounted () {
  },
  methods:{
    goBack(){
      this.$router.go(-1)
    },
    onLoad(){
      this.loading = true
      this.page.current_page=parseInt(this.page.current_page) + 1
      ajax.getList({
        table:'withdrawLog',
        scence:'mg_withdrawLog',
        page:this.page.current_page,
        page_size:this.page.page_size,
        filter:this.filter
      }).then(res=>{
        this.loading=false
        res.data.map(item=>{
          this.list.push(item)
        })
        if(parseInt(res.current_page)>=res.last_page){
          this.finished=true
        }
      }).catch(e=>{
        this.loading=false
        this.finished=true
        this.$toast(e.msg)
      })
    },
    onRefresh() {
      this.list=[]
      this.page={
        current_page:0,
        page_total:1,
        count:0,
        page_size:10,
      }
      this.isLoading = false;
      this.loading = true;
      this.finished = false;
      this.onLoad()
    },
    // wx_text 现在存的是 v3 商家转账的原始返回 JSON，失败时取其中的原因文案展示
    failReason(item){
      let text = item.wx_text || ''
      if(!text) return '未知原因'
      if(text.charAt(0)==='{'){
        try{
          const obj = JSON.parse(text)
          return obj.error || obj.fail_reason || '系统处理中'
        }catch(e){
          return text
        }
      }
      return text
    },
    // 拉起微信「用户确认收款」页面（取参 + 签名 + 调起，逻辑见 @/libs/transfer）
    confirmReceive(item){
      if(this.confirmingId) return
      this.confirmingId = item.id
      confirmReceipt({kind:'withdraw', id:item.id}, {
        onSuccess: ()=>{
          // 仅代表确认页正常返回，不代表已到账（到账以服务端回调为准）
          this.$toast('已提交，到账结果请稍后查看')
          setTimeout(()=>this.onRefresh(),1500)
        },
        onCancel: ()=>{
          this.$toast('你取消了收款')
        },
        onError: (msg)=>{
          this.$toast(msg)
          // 状态可能已变化（已到账 / 已失败），刷新列表
          this.onRefresh()
        },
        onDone: ()=>{
          this.confirmingId = 0
        }
      })
    }
  }
}
</script>

<style scoped>
.tinfo{color:#fff;}
.orderCon{padding:10px 20px;line-height: 20px;font-size: 12px;}
.coinlist{border-bottom:1px solid #f3f3f3;background:#fff;padding:10px;}
.coinlist .number{font-size:20px;text-align:right;color:#ff6600;}
.confirmBox{text-align:right;}
</style>
